if ( typeof QuickBuy !== 'function' ) {

	class QuickBuy extends HTMLElement {

		constructor(){

			super();

			// Product variant event listener for theme specific logic

			this.firstLoad = true
			// False until the first successful card-image update (load uses instant slide jump)
			this._initialImageApplied = false

			this.zIndex = 99;

			const hasProductItem = this.closest('[data-js-product-item]');

			this.productVariants = this.querySelector('product-variants');

			if ( hasProductItem ) {

				// Non-gallery mode: hidden <template> nodes with variant media
				this.variantImages = this.querySelector('[data-js-quick-buy-product-images]');
				this.productImage = this.closest('[data-js-product-item]').querySelector('[data-js-product-item-image]');
				// Gallery mode: product card thumbnail is a css-slider of product.images
				this.variantImagesSliders = this.hasAttribute('data-variant-images-slider');
				// Must scope to the card image — product-item also has colour-swatch css-sliders
				this.productSlider = this.productImage?.querySelector('css-slider') || null;

				this._quickBuyPrice = this.productVariants.dataset.buyButtonPrice;
				this._defaultToFirstVariant = this.productVariants.hasAttribute('data-variant-required') ? false : true;

			}

			this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
			// Swatch click fires before async option_values fetch finishes — update image immediately
			this.productVariants.addEventListener('change', () => {
				this.updateProductItemImage(this.productVariants.currentVariant);
			});
			// Apply correct variant/colour image on first paint (not only after user interaction)
			this.onVariantChangeHandler({target:this.productVariants});

			if ( this.variantImages ) {

				setTimeout(()=>{
					const imageObserver = new IntersectionObserver((entries, observer) => {
						if ( ! entries[0].isIntersecting ) {
							return;
						} else {
							this.variantImages.querySelectorAll(`template`).forEach(elm=>{
								if ( ! elm.dataset.init ) {
									this.initVariantImage(elm);
								}
							});
							observer.unobserve(this);
						}
					});
					imageObserver.observe(this);
				}, 5000)

			}

			setTimeout(()=>{

				this.querySelectorAll('.product-variant__item--radio input').forEach(input=>{

					input.addEventListener('click', () => {

						const inputParent = input.closest('.product-variant__item--radio');
						inputParent.closest('.css-slider-holder').scrollTo({
							top: 0,
							left: inputParent.offsetLeft - 40,
							behavior: 'smooth'
						});

						if ( inputParent.classList.contains('product-variant__item--color' ) ) {
							inputParent.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = input.value;
						}

					})

				});
			}, 1000);

			// trigger cart popup

			if ( this.querySelector('[data-js-quick-buy-form]') ) {
				this.querySelector('form').addEventListener('submit', e=>{

					e.preventDefault();

					const submitButton = this.querySelector('[type="submit"]');
					submitButton.classList.add('working');

					window.handleAddToCart(
						this._serializeForm(e.currentTarget), 1,
						{
							'Content-Type': 'application/x-www-form-urlencoded',
							'X-Requested-With': 'XMLHttpRequest'
						},
						()=>{
							submitButton.classList.remove('working');
						}
					);

				});

			}

			// update product card details

			setTimeout(()=>{

				if ( this._defaultToFirstVariant ) {

					if ( hasProductItem.querySelector('[data-js-product-item-price]') ) {

						hasProductItem.querySelector('[data-js-product-item-price]').innerHTML = hasProductItem.querySelector('[data-js-product-default-price-data]').innerHTML;

						const buttonPrice = this.querySelector('[data-js-product-add-to-cart-text]');
						const button = this.querySelector('[data-js-product-add-to-cart]')
						const productPrice = this.querySelector('[data-js-quick-buy-product-price]');

						if ( this.dataset.addToCartPrice == "true" && !button.classList.contains('disabled') && !button.hasAttribute('data-price') ) {
							if ( this.dataset.singleVariant != "true" ) {
								buttonPrice.innerHTML = `${buttonPrice.innerHTML} <span class='element--hide-on-small'>- ${productPrice.innerHTML}</span>`;
							}
						}

					}

					this.querySelectorAll('.product-variant__item--color [data-selected]').forEach(elm=>{
						if ( ! elm.hasAttribute('data-silent-selected') ) {
							elm.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = elm.value;
						}
					});

				}

			}, 10);

			setTimeout(()=>{
				if ( ! this._defaultToFirstVariant ) {
					this.querySelectorAll('.product-variant__item--color [data-product-url][data-selected]').forEach(elm=>{
						if ( ! elm.hasAttribute('data-silent-selected') ) {
							elm.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = elm.value;
						}
					});
					if ( parseInt(this.querySelector('product-variants').dataset.variants) == 1 ) {
						this.querySelector('product-variants').updateBuyButtons();
					}
				}
			}, 1);

		}

		onVariantChangeHandler(e){

			const variant = e.target.currentVariant;

			// Card thumbnail: always run (page load + option change). Does not require
			// a full available variant — colour option image data is enough on PLP.
			this.updateProductItemImage(variant);

			if ( variant ) {

				// Refresh delivery badge for this variant via Sections API
        this.updateDeliveryTag(variant);

				// Sync any "original price" display on the product card
				const priceOriginal = e.target.closest('[data-js-product-item]');
				if(priceOriginal) {
					const priceOrginalHtml = priceOriginal.querySelector('[data-js-product-price-original]');
					if ( priceOrginalHtml ) {
						priceOrginalHtml.innerHTML = this._formatMoney(variant.price, KROWN.settings.shop_money_format);
						priceOrginalHtml.dataset.price = variant.price;
					}
				}

			}

			this.firstLoad = false

		}

		/**
		 * Resolve media/image ids for the product card thumbnail.
		 *
		 * Order of preference:
		 * 1. Selected / checked options (visible colour first — compact PLP hides size etc.)
		 * 2. First visible colour option that carries image data (page load fallback)
		 * 3. currentVariant.featured_media / featured_image
		 *
		 * Option values expose data-featured-image-id / data-featured-media-id from Liquid.
		 */
		getVariantImageIds(variant) {
			let mediaId = null;
			let imageId = null;

			// Prefer checked/selected controls; visible options first (colour on PLP)
			const selectedEls = [
				...this.querySelectorAll('.product-variant:not(.u-hide) .product-variant-value:checked'),
				...this.querySelectorAll('.product-variant:not(.u-hide) select option:checked'),
				...this.querySelectorAll('.product-variant:not(.u-hide) [data-option-value-id][data-selected]'),
				...this.querySelectorAll('.product-variant-value:checked'),
				...this.querySelectorAll('select option:checked'),
				...this.querySelectorAll('[data-option-value-id][data-selected]')
			];

			for ( const el of selectedEls ) {
				// Skip "Choose option" placeholders
				if ( el.hasAttribute('data-disabled') ) continue;

				if ( ! mediaId && el.dataset.featuredMediaId ) {
					mediaId = el.dataset.featuredMediaId;
				}
				if ( ! imageId && el.dataset.featuredImageId ) {
					imageId = el.dataset.featuredImageId;
				}
				// First option that carries image data wins (typically Colour)
				if ( mediaId || imageId ) break;
			}

			// Nothing selected yet: use first visible colour/option with image attrs
			if ( ! mediaId && ! imageId ) {
				const firstColourOption = this.querySelector(
					'.product-variant:not(.u-hide) .product-variant-value[data-featured-image-id], ' +
					'.product-variant:not(.u-hide) .product-variant-value[data-featured-media-id], ' +
					'.product-variant:not(.u-hide) option[data-featured-image-id], ' +
					'.product-variant:not(.u-hide) option[data-featured-media-id]'
				);
				if ( firstColourOption ) {
					mediaId = firstColourOption.dataset.featuredMediaId || null;
					imageId = firstColourOption.dataset.featuredImageId || null;
				}
			}

			// Fall back to the resolved variant JSON (may be missing for some combos)
			if ( ! mediaId ) mediaId = variant?.featured_media?.id || null;
			if ( ! imageId ) imageId = variant?.featured_image?.id || null;

			return { mediaId, imageId };
		}

		/**
		 * Show the matching thumbnail for the current colour/variant on the product card.
		 * Supports:
		 * - Gallery slider (product_card_thumbnail_gallery): changeSlide to product-item__image-{id}
		 * - Overlay templates (no gallery): clone <template data-media-id> onto the card image
		 */
		updateProductItemImage(variant) {
			if ( ! this.productImage && ! this.variantImagesSliders && ! this.variantImages ) {
				return;
			}

			const { mediaId, imageId } = this.getVariantImageIds(variant);

			// --- Non-gallery: stacked figures from hidden templates ---
			if ( this.variantImages ) {
				const id = mediaId || imageId;
				if ( ! id ) return;

				let variantImg = this.variantImages.querySelector(`template[data-media-id="${id}"]`);
				// featured_image.id may not match media.id — templates also store data-image-id
				if ( ! variantImg && imageId ) {
					variantImg = this.variantImages.querySelector(`template[data-image-id="${imageId}"]`);
				}
				if ( ! variantImg ) return;

				if ( ! variantImg.dataset.init ) {
					this.initVariantImage(variantImg);
				}
				this.showVariantImage(variantImg.dataset.mediaId || id);
				this._initialImageApplied = true;
				return;
			}

			// --- Gallery slider: jump to the slide whose class is product-item__image-{imageId} ---
			if ( this.variantImagesSliders && this.productSlider ) {
				const id = imageId || mediaId;
				if ( ! id ) return;

				const goToVariantSlide = () => {
					const variantImg =
						this.productSlider.querySelector(`.product-item__image-${id}`) ||
						this.productImage?.querySelector(`.product-item__image-${id}`);

					// data-index is set when css-slider finishes init
					if ( ! variantImg || variantImg.dataset.index === undefined ) return false;

					// Instant jump on first paint so the default first image does not flash
					const useInstant = ! this._initialImageApplied;
					const prevBehavior = this.productSlider.o?.scrollBehavior;
					if ( useInstant && this.productSlider.o ) {
						this.productSlider.o.scrollBehavior = 'instant';
					}
					this.productSlider.changeSlide(variantImg.dataset.index);
					if ( useInstant && this.productSlider.o && prevBehavior !== undefined ) {
						this.productSlider.o.scrollBehavior = prevBehavior;
					}
					this._initialImageApplied = true;
					return true;
				};

				if ( goToVariantSlide() ) return;

				// Slider not ready yet — retry once on its "ready" event
				if ( ! this._sliderImageReadyBound ) {
					this._sliderImageReadyBound = true;
					this.productSlider.addEventListener('ready', () => {
						this.updateProductItemImage(this.productVariants?.currentVariant);
					}, { once: true });
				}
			}
		}

		updateDeliveryTag(variant) {
			if (!variant?.id) return;

			const productItem = this.closest('[data-js-product-item]');
			if (!productItem) return;

			const tagWrapper = productItem.querySelector('.js-product-item-tag-wrapper');
			// No tag slot on this card — leave inputs alone
			if (!tagWrapper) return;

			// Block interaction without using disabled= (that falsely triggers out-of-stock UI)
			this.setVariantInputsLocked(true);

			// Product url + variant param + request tag section
			const productHandle = this.productVariants.dataset.url.split('/').pop().split('?')[0];
			const sectionId = 'product-card-tags';

			const url = `${window.Shopify.routes.root}products/${productHandle}?variant=${variant.id}&section_id=${sectionId}`;

			fetch(url, {
				method: 'GET',
        headers: {
            'Content-Type': 'text/html',
        },
        credentials: 'include'
			})
				.then(response => {
					if (!response.ok) throw new Error(`Tag section fetch failed: ${response.status}`);
					return response.text();
				})
				.then(html => {
					// Remove old tag
					tagWrapper.innerHTML = '';

					// Insert new tag
					if (html.trim()) {
						tagWrapper.innerHTML = html.trim();
					}
				})
				.catch(err => {
					console.warn('Failed to update delivery tag via Sections API:', err);
					// Remove tag if request fails
					tagWrapper.innerHTML = '';
				})
				.finally(() => {
					this.setVariantInputsLocked(false);
				});
		}

		/**
		 * Soft-lock variant pickers during async work (e.g. delivery tag fetch).
		 * Uses pointer-events + aria-busy — never the disabled attribute, which
		 * makes updateOutOfStockVariants think every option is unavailable.
		 */
		setVariantInputsLocked(locked) {
			const productVariants = this.productVariants || this.querySelector('product-variants');
			if (!productVariants) return;

			if (locked) {
				productVariants.style.pointerEvents = 'none';
				productVariants.setAttribute('aria-busy', 'true');
			} else {
				productVariants.style.pointerEvents = '';
				productVariants.removeAttribute('aria-busy');
			}
		}

		// Clone a variant media <template> into the card image stack (non-gallery mode)
		initVariantImage(template) {
			template.dataset.init = true;
			const image = template.content.querySelector('figure').cloneNode(true);
			image.dataset.mediaId = template.dataset.mediaId;
			this.productImage.append(image);
		}

		// Bring a cloned variant figure to the front of the card image stack
		showVariantImage(id) {
			if ( ! this.productImage || ! id ) return;
			const figure = this.productImage.querySelector(`[data-media-id="${id}"]`);
			if ( ! figure ) return;

			this.productImage.querySelector('.product-item__image-figure--on-top')?.classList.remove('product-item__image-figure--on-top');
			figure.classList.add('product-item__image-figure--on-top');
			const img = figure.querySelector('img');
			// Force srcset re-evaluation after reveal
			if ( img?.srcset ) img.srcset = img.srcset;
			figure.style.zIndex = ++this.zIndex;
		}

		_serializeForm(form) {
			let arr = [];
			Array.prototype.slice.call(form.elements).forEach(function(field) {
				if (
					!field.name ||
					field.disabled ||
					['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
				)
					return;
				if (field.type === 'select-multiple') {
					Array.prototype.slice.call(field.options).forEach(function(option) {
						if (!option.selected) return;
						arr.push(
							encodeURIComponent(field.name) +
								'=' +
								encodeURIComponent(option.value)
						);
					});
					return;
				}
				if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
					return;
				arr.push(
					encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
				);
			});
			return arr.join('&');
		}

		_formatMoney(cents, format) {
			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}

			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;

			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';

				if (isNaN(number) || number === null) {
					return 0;
				}

				number = (number / 100.0).toFixed(precision);

				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';

				return dollarsAmount + centsAmount + KROWN.settings.iso_code;
			}

			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}

			return formatString.replace(placeholderRegex, value);
		}

	}

	if ( typeof customElements.get('quick-buy') == 'undefined' ) {
		customElements.define('quick-buy', QuickBuy);
	}

}

if ( ! window.handleAddToCart ) {

	window.handleAddToCart = (body, items, headers, callback) => {

		let alert = '';

		fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
			body: body,
			headers: headers,
			method: 'POST'
		})
		.then(response => response.json())
		.then(response => {
			if ( response.status == 422 ) {
				// wrong stock logic alert
				alert = document.createElement('span');
				alert.className = 'alert alert--error';
				alert.innerHTML = response.description
				return fetch('?section_id=helper-cart');
			} else {
				return fetch('?section_id=helper-cart');
			}
		})
		.then(response => response.text())
		.then(text => {

			let doNext = false;

			if ( document.body.classList.contains('template-cart' ) ) {
				doNext = "page";
			} else {
				if ( KROWN.settings.cart_popup == "true" && document.getElementById('mini-cart-popup') ) {
					doNext = "popup";
				} else if ( KROWN.settings.cart_action == "overlay" && document.getElementById('site-cart-sidebar') ) {
					doNext = "drawer";
				} else {
					doNext = "page";
				}
			}

			if ( doNext == "page" ) {
				window.location.href = KROWN.settings.routes.cart_url;
			} else {

				const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');

				// Show / hide header cart icon
				const cartCount = parseInt(sectionInnerHTML.querySelector('[data-cart-count]').textContent.trim()) || 0;
				document.querySelectorAll('.js-cart-icon').forEach(icon => {
					if (cartCount === 0) {
						icon.classList.add('u-hide');
					} else {
						icon.classList.remove('u-hide');
					}
				});

				if ( document.getElementById('site-cart-sidebar') ) {

					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					if ( document.getElementById('cart-recommendations-sidebar') ) {
						document.getElementById('cart-recommendations-sidebar').generateRecommendations();
					}

					if ( alert != '' ) {
						document.getElementById('AjaxCartForm').querySelector('form').prepend(alert);
					}
					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

				}

				if ( doNext == "drawer" ) {
					document.getElementById('site-cart-sidebar').show();
				} else {
					const miniCartPopup = document.getElementById('mini-cart-popup')
					if ( items == 1 ) {
						miniCartPopup.querySelector('[data-js-mini-cart-single]').style.display = 'block';
						miniCartPopup.querySelector('[data-js-mini-cart-plural]').style.display = 'none';
					} else {
						miniCartPopup.querySelector('[data-js-mini-cart-plural]').style.display = 'block';
						miniCartPopup.querySelector('[data-js-mini-cart-plural]').innerHTML = KROWN.settings.locales.cart_added_items_count.replace('{{ count }}', items);
						miniCartPopup.querySelector('[data-js-mini-cart-single]').style.display = 'none';
					}
					miniCartPopup.show();
					if ( miniCartPopup.dataset.hide != '0' ) {
						setTimeout(()=>{
							miniCartPopup.hide();
						}, parseInt(miniCartPopup.dataset.hide));
					}
				}

			}

		})
		.catch(e => {
			console.log(e);
		})
		.then(() => {
			const event = new Event('addToCart')
			document.dispatchEvent(event)
		})
		.finally(() => {
			callback();
		});

	}

}

if ( typeof QuickAddToCart !== 'function' ) {

	class QuickAddToCart extends HTMLElement {
		constructor(){
			super();
			if ( this.querySelector('product-form') ) {
				this.init();
			}
		}
		init(){
			this.querySelector('product-form').addEventListener('add-to-cart', ()=>{

				let doNext = "";

				if ( document.body.classList.contains('template-cart' ) ) {
					doNext = "page";
				} else {
					if ( KROWN.settings.cart_popup == "true" && document.getElementById('mini-cart-popup') ) {
						doNext = "popup";
					} else if ( KROWN.settings.cart_action == "overlay" && document.getElementById('site-cart-sidebar') ) {
						doNext = "drawer";
					} else {
						doNext = "page";
					}
				}

				if ( doNext == "page" ) {
					window.location.href = KROWN.settings.routes.cart_url;
				} else {

					if ( doNext == "drawer" ) {
						document.getElementById('site-cart-sidebar').show();
					} else {
						const miniCartPopup = document.getElementById('mini-cart-popup')
						miniCartPopup.querySelector('[data-js-mini-cart-single]').style.display = 'block';
						miniCartPopup.querySelector('[data-js-mini-cart-plural]').style.display = 'none';
						miniCartPopup.show();
						if ( miniCartPopup.dataset.hide != '0' ) {
							setTimeout(()=>{
								miniCartPopup.hide();
							}, parseInt(miniCartPopup.dataset.hide));
						}
					}

				}

			});
		}
	}

	if ( typeof customElements.get('quick-add-to-cart') == 'undefined' ) {
		customElements.define('quick-add-to-cart', QuickAddToCart);
	}

}

if ( typeof QuickViewProduct !== 'function' ) {

	class QuickViewProduct extends HTMLElement {
		constructor(){
			super();
			if ( this.querySelector('a') ) {
				this.init();
			}
		}

		initModalProduct(){

			this.quickViewModal.querySelector('.product-quick-view__close').addEventListener('click', ()=>{
				this.quickViewModal.hide();
			});

			if ( this.quickViewModal.querySelector('[data-js-product-form]') ) {
				this.quickViewModal.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
					document.getElementById('site-cart-sidebar')?.scrollTo({top: 0, behavior: 'smooth'});
					this.quickViewModal.hide();
				});
			}

			if ( Shopify && Shopify.PaymentButton ) {
				setTimeout(()=>{
					Shopify.PaymentButton.init();
				}, 50);
			}

			const productVariants = this.quickViewModal.querySelector('product-variants');
			if ( ! productVariants._defaultToFirstVariant ) {
				productVariants.querySelectorAll('.product-variant__item--color [data-product-url][data-selected]').forEach(elm=>{
					if ( ! elm.hasAttribute('data-silent-selected') ) {
						elm.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = elm.value;
					}
				});
				if ( parseInt(productVariants.dataset.variants) == 1 ) {
					productVariants.updateBuyButtons();
				}
			}

		}

		init(){

			this.quickViewModal = null;
			this.querySelector('a').addEventListener('click', (e)=>{

				e.preventDefault();

				if ( ! this.quickViewModal ) {

					const target = e.currentTarget;

					target.classList.add('working');

					fetch(`${target.getAttribute('href')}${ target.getAttribute('href').includes('?') ? '&' : '?' }view=quick-view`)
						.then(response => response.text())
						.then(text => {

							const quickViewHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('#product-quick-view');

							// create modal w content

							const quickViewContainer = document.createElement('div');
							quickViewContainer.innerHTML = `<modal-box id="modal-${target.dataset.id}"
								class="modal modal--product"
								data-options='{
									"enabled": false,
									"showOnce": false,
									"blockTabNavigation": true
								}'
								tabindex="-1" role="dialog" aria-modal="true"
							>
								<div class="container--medium">
									<div class="modal-content" data-js-product-page>
										<button class="modal-close" data-js-close data-js-first-focus style="position:absolute;margin:0;top:0;right:0">${window.KROWN.settings.symbols.close}</button>
									</div>
								</div>
								<span class="modal-background" data-js-close></span>
							</modal-box>`;

							this.quickViewModal = quickViewContainer.querySelector('modal-box');
							document.body.appendChild(this.quickViewModal);
							this.quickViewModal.querySelector('.modal-content').innerHTML = quickViewHTML.innerHTML;

							setTimeout(()=>{
								this.initModalProduct();
							}, 100);
							this.quickViewModal.querySelector('[data-js-product-page]').addEventListener('reload', ()=>{
								this.initModalProduct();
							})

							if ( ! window.productPageScripts ) {
								const scripts = this.quickViewModal.querySelectorAll('script');
								scripts.forEach(elm=>{
									const script = document.createElement('script');
									script.src = elm.src;
									document.body.append(script);
									window.productPageScripts = true;
								});
							}

							setTimeout(()=>{
								this.quickViewModal.show();
								target.classList.remove('working');
							}, 250);

						})
						.then(() => {
							const event = new Event('modalOpen')
							document.dispatchEvent(event)
						})

				} else {
					this.quickViewModal.show();
				}

			})
		}
	}

	if ( typeof customElements.get('quick-view-product') == 'undefined' ) {
		customElements.define('quick-view-product', QuickViewProduct);
	}

}

if ( ! KROWN.productItemUpdateHelper ) {

	KROWN.productItemUpdateHelper = (productItem, productId, html, skeleton) => {

		const truncate = (str, max = 10) => {
			const array = str.trim().split(' ');
			const ellipsis = array.length > max ? '...' : '';
			return array.slice(0, max).join(' ') + ellipsis;
		};

		productItem.id = `product-item-${productId}`;

		// update thumbnail

		productItem.querySelector('.product-item__image').innerHTML = html.querySelector('.product-item__image').innerHTML;
		productItem.querySelectorAll('.product-item__image img[sizes]').forEach(img=>{
			img.setAttribute('sizes', skeleton.settings.product_image_sizes);
		});

		// update inner content

		productItem.querySelector('.product-item__text').innerHTML = '';
		skeleton.elements.forEach(elm=>{

			let classNames = elm.className;
			if ( classNames ) {
				let newElement= html.querySelector('.' + classNames.split(' ').join('.'));
				if ( newElement ) {
					productItem.querySelector('.product-item__text').append(newElement);
					if ( classNames.includes('product-item__link') ) {
						newElement.querySelector('.product-item__link .button__text').textContent = skeleton.settings.product_link_button_label;
					} else if ( classNames.includes('product-item__excerpt') ) {
						if ( ! ( skeleton.settings.product_description_excerpt_link === true ) ) {
							newElement.querySelector('.product-item__excerpt-link').remove();
						}
						newElement.querySelector('.product-item__excerpt-text').textContent = truncate(newElement.querySelector('.product-item__excerpt-text').textContent, skeleton.settings.product_description_excerpt_length);
					}
				}

			}
		});

		// reset some settings

		if ( skeleton.settings.defer_add == 'true' ) {
			productItem.querySelector('[data-js-product-add-to-cart]').classList.remove('button', 'button--solid', 'button--outline', 'button--outline-hover-solid', 'button--fullwidth', 'button--loader', 'button--move')
		} else {
			productItem.querySelector('.defer-checkmark')?.remove();
		}

		if ( skeleton.settings.show_add_to_cart_price && productItem.querySelector('quick-buy') ) {
			productItem.querySelector('quick-buy').dataset.addToCartPrice = "true";
		}

		if ( skeleton.settings.unavailable_variants != 'hide' ) {
			if ( skeleton.settings.unavailable_variants == 'show' ) {
				productItem.querySelector('product-variants').setAttribute('data-hide-variants', 'true');
				productItem.querySelectorAll('[data-option-value-id]').forEach(elm=>{
					elm.removeAttribute('disabled');
				});
			} else if ( skeleton.settings.unavailable_variants == 'disable' ) {
				productItem.querySelector('product-variants').setAttribute('data-hide-variants', 'disable');
			}
			productItem.querySelector('product-variants').setAttribute('data-unavailable-variants', skeleton.settings.unavailable_variants);
			productItem.querySelector('product-variants').classList.remove('product-variants--hide-unavailable');
			productItem.querySelector('.product-variant__out-of-stock')?.remove();

		}

	}

}
